<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  doNotAdoptFlag?: boolean;
  doNotFosterFlag?: boolean;
  status?: string;
  tags?: any[];
}>();

const doNotAdoptTagColor = computed(
  () => props.tags?.find((tag) => tag.value?.toLowerCase() === 'do not adopt')?.color
);
const doNotFosterTagColor = computed(
  () => props.tags?.find((tag) => tag.value?.toLowerCase() === 'do not foster')?.color
);
</script>

<template>
  <div class="flex flex-wrap gap-2">
    <div
      v-if="status === 'deleted'"
      class="w-fit rounded border-none bg-[#A71727] px-2 py-1 text-xs font-semibold"
    >
      <p class="text-white">{{ $t('filters.options.deleted') }}</p>
    </div>

    <div
      v-if="doNotAdoptFlag"
      class="w-fit text-nowrap rounded border-none px-2 py-1 text-xs font-semibold"
      :style="`background-color: ${doNotAdoptTagColor || '#A71727'}`"
    >
      <p class="text-white">{{ $t('filters.options.doNotAdopt') }}</p>
    </div>

    <div
      v-if="doNotFosterFlag"
      class="w-fit text-nowrap rounded border-none px-2 py-1 text-xs font-semibold"
      :style="`background-color: ${doNotFosterTagColor || '#A71727'}`"
    >
      <p class="text-white">{{ $t('filters.options.doNotFoster') }}</p>
    </div>
  </div>
</template>
